import { render, staticRenderFns } from "./DevButtons.vue?vue&type=template&id=cb3f79b8&scoped=true&lang=pug&"
import script from "./DevButtons.vue?vue&type=script&lang=ts&"
export * from "./DevButtons.vue?vue&type=script&lang=ts&"
import style0 from "./DevButtons.vue?vue&type=style&index=0&id=cb3f79b8&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3f79b8",
  null
  
)

export default component.exports